import { Weak } from "../../../../helpers";
import { PropsUIPageEnd } from "../../../../types/pages";
import { ReactFactoryContext } from "../../factory";
import { Page } from "./templates/page";
import TextBundle from "../../../../text_bundle";
import { Translator } from "../../../../translator";
import { BodyLarge, Title1 } from "../elements/text";
import { JSX } from "react";
import React from "react";

type Props = Weak<PropsUIPageEnd> & ReactFactoryContext;

export const EndPage = (props: Props): JSX.Element => {
  const { title, text, prolificText, prolificLink, prolificCode } = prepareCopy(props);

  const body: JSX.Element = (
    <>
      <Title1 text={title} />
      <BodyLarge text={text} />
      {prolificText && (
        <div className="mt-8 flex flex-col gap-4">
          <BodyLarge text={prolificText} margin="mb-0" />
          <a
            href={prolificLink}
            target="_blank"
            rel="noopener noreferrer"
            className="text-bodylarge font-body text-blue-600 underline"
          >
            {prolificLink}
          </a>
          <BodyLarge text={prolificCode} margin="mb-0" />
        </div>
      )}
    </>
  );

  return <Page body={body} />;
};

interface Copy {
  title: string;
  text: string;
  prolificText?: string;
  prolificLink?: string;
  prolificCode?: string;
}

function prepareCopy({ locale }: Props): Copy {
  const copy: Copy = {
    title: Translator.translate(title, locale),
    text: Translator.translate(text, locale),
  };

  if (locale === "en") {
    copy.prolificText = "If you are a Prolific participant, please follow this link:";
    copy.prolificLink = "https://app.prolific.com/submissions/complete?cc=C9EIDT69";
    copy.prolificCode = "Completion code: C9EIDT69";
  }

  return copy;
}

const title = new TextBundle()
  .add("en", "Thank you")
  .add("de", "Danke")
  .add("it", "Grazie")
  .add("nl", "Bedankt");

const text = new TextBundle()
  .add(
    "en",
    "Thank you for your participation."
  )
  .add(
    "de",
    "Herzlichen Dank für Ihre Teilnahme. Sie können diese Seite nun schließen oder die Seite aktualisieren, um die Datenspende erneut durchzuführen."
  )
  .add(
    "it",
    "Grazie per la tua partecipazione. Ora puoi chiudere la pagina o aggiornare per riavviare il flusso di donazione."
  )
  .add(
    "nl",
    "Hartelijk dank voor uw deelname. U kunt deze pagina nu sluiten of de pagina verversen om de flow nogmaals te doorlopen."
  );
